import React from 'react';
import { useAtomValue } from '@exodus/headless-ui';
import { isExchangingAtom, visibleErrorAtom } from '../../../atoms/index.js';
const ErrorComponent = ({ Component, className, style }) => {
    const currentError = useAtomValue(visibleErrorAtom);
    const isExchanging = useAtomValue(isExchangingAtom);
    if (!currentError || !Component || isExchanging)
        return null;
    return (React.createElement(Component, { type: currentError.type, reason: currentError.reason, payload: currentError.payload, className: className, style: style }));
};
export default ErrorComponent;
